import { dropdownValuesService } from "services";

let requestCache:
	| {
			id: string | number;
			displayName: string;
	  }[]
	| null = null;

const loadRoles = async (search, prevOptions, { page }) => {
	if (requestCache === null || search.length === 0) {
		requestCache = await dropdownValuesService.getUserRoles();
	}

	return {
		options: requestCache
			?.sort((a, b) => (a.displayName > b.displayName ? 1 : -1))
			.filter(item =>
				item?.displayName
					?.toLowerCase()
					?.includes(search?.toLowerCase()),
			),
		hasMore: false,
		additional: {
			page: page + 1,
		},
	};
};

const rolesColumn = () => ({
	name: "role",
	type: "select" as const,
	loadOptions: loadRoles,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Role",
});

export default rolesColumn;
